module.exports = __webpack_public_path__ + "static/img/B高清显示屏.c7522fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3-model/B高清显示屏.png
// module id = 0vZe
// module chunks = 0